<template>
  <div :class="{ 'help-text': true, 'err-text': error, 'center-text': center }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "HelpText",
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~PublicStyles/_variables.scss";
.help-text {
  color: $blue;
  margin: 10px 0 20px;
  display: block;
  font-size: 14px;
  font-weight: 400;
}

.center-text {
  text-align: center;
}

.err-text {
  color: $error;
}
</style>
